import styled from 'styled-components';

const Paragraph = styled.p`
	font-size: 14px;
	display: inline-block;
`;

export default Paragraph;
